import { useCallback, useLayoutEffect, useMemo, useState } from "react";
import debounce from "lodash/debounce";

interface UseDelayedUpdateInputProps<T> {
  value: T;
  onChange: (value: T) => void;
}

export function useDelayedUpdateInput<T>({ value, onChange }: UseDelayedUpdateInputProps<T>) {
  const [internalValue, setInternalValue] = useState(value);
  useLayoutEffect(() => setInternalValue(value), [value]);

  onChange = useMemo(() => {
    return debounce(onChange, 500);
  }, [onChange]);

  const onChangeCb = useCallback(
    (value: T) => {
      setInternalValue(value);
      onChange(value);
    },
    [onChange]
  );

  return {
    value: internalValue,
    onChange: onChangeCb,
  };
}
